import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import { getWorkingItemsFromChecks } from "../../../../util/common";

import { TurboHoetHeader, TotalAmount, ImageGallery, FixedItems, NotFixedItems, WorkingItems, TiresOverview, Signatures, VatIndicator } from "../../components";

class TurboHoetCheckTemplate extends Component {
  renderMainContent = () => {
    const { settings, communication, t } = this.props;

    const fixedItems = FixedItems.filterFixedItems(communication.appointment.interventions);
    const notFixedItems = NotFixedItems.filterNotFixedItems(communication.appointment.interventions);
    const workingItems = WorkingItems.filterWorkingsItems(getWorkingItemsFromChecks(communication.appointment.checks));
    const lettersMap = ImageGallery.getLettersMap(fixedItems, notFixedItems, workingItems);
    const signatureItems = Signatures.filterSignatureItems(communication.appointment.interventions);

    return (
      <div className="mainContent">
        <div className="simple-header-container">
          <h1>{t("cc_turbocharge_rating").message || "Turbocharger rating"}</h1>
        </div>
        <TurboHoetHeader settings={settings} communication={communication} />
        <FixedItems lettersMap={lettersMap} fixedItems={fixedItems} settings={settings} communication={communication} />
        {fixedItems.length > 0 && <TotalAmount communication={communication} settings={settings} />}
        <ImageGallery lettersMap={lettersMap} />
        <NotFixedItems lettersMap={lettersMap} notFixedItems={notFixedItems} settings={settings} communication={communication} />
        <TiresOverview communication={communication} settings={settings} />
        <WorkingItems lettersMap={lettersMap} workingItems={workingItems} communication={communication} />
        <Signatures signatureItems={signatureItems} settings={settings} communication={communication} />
        <VatIndicator include_vat={settings.include_vat} />
      </div>
    );
  };

  render() {
    return <div className="report-template-v2">{this.renderMainContent()}</div>;
  }
}

export default withTranslation()(TurboHoetCheckTemplate);
